@if (showGlobalSpinner) {
  <div class="dialog-spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}

<div class="adhoc-upload-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <div class="dialog-title">Upload Ad-Hoc Notifications File</div>

    <button type="button" class="dialog-close-bt" (click)="close()">✕</button>
  </div>
  <!-- Body -->
  <div class="dialog-body">
    <!-- Selected file (readonly) -->
    <div class="field">
      <label class="field-label">Selected file</label>
      <div class="file-row">
        <input class="file-name-input" type="text" [value]="fileName || ''" placeholder="No file selected" readonly />
        <button class="choose-btn" mat-raised-button color="primary" type="button" (click)="openFilePicker()">
          Choose File
        </button>
        <!-- Clear-->
        <button class="icon-btn" matTooltip="Clear" matTooltipPosition="above" mat-icon-button type="button"
          (click)="resetFileSelection()" [disabled]="!fileName">
          <mat-icon color="warn">close</mat-icon>
        </button>
        <!-- Upload -->
        <button class="icon-btn" matTooltip="Upload" matTooltipPosition="above" mat-icon-button type="button"
          (click)="uploadFile()" [disabled]="disableUploadCta">
          <mat-icon>done</mat-icon>
        </button>
      </div>
      <!-- Hidden native input (NO duplicate UI) -->
      <input #fileInput class="native-file-input" type="file" accept=".csv" (change)="uploadFileEvt($event)" />
      <div class="note">Note: Upload only csv file up to 700 KB.</div>
      @if (fileNameMismatch) {
        <div class="msg error">
          {{ invalidFileMessage }}
        </div>
      }
      @if (fileError) {
        <div class="msg error">
          {{ invalidFileMessage }}
        </div>
      }
    </div>
    <!-- Errors -->
    @if (invalidEvents?.length) {
      <div class="msg error strong">
        The Ad-Hoc notifications were not sent/scheduled due to the following errors.
      </div>
      <div class="errors-box">
        <div class="errors-scroll">
          @for (invalidEvent of invalidEvents; track invalidEvent) {
            <div class="error-item">
              • {{ invalidEvent?.rowNumber }}, {{ invalidEvent?.errorMsg || 'N/A' }}
            </div>
          }
        </div>
      </div>
    }
  </div>
  <!-- Footer (intentionally left blank; dialog is closed via the header close button) -->
</div>